import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, MapPin, List, Navigation, Info } from 'lucide-react';

export const MobileBottomNav = ({ 
  currentEvent, 
  currentEventIndex, 
  totalEvents,
  onPrevEvent,
  onNextEvent,
  onEventClick,
  onFindNearest,
  viewMode,
  onViewModeChange
}) => {
  return (
    <motion.div
      data-testid="mobile-bottom-nav"
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.4, delay: 0.3 }}
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-100 shadow-[0_-4px_30px_rgba(0,0,0,0.1)]"
    >
      {/* Event info bar */}
      <div className="px-4 pt-3 pb-2">
        <div className="flex items-center justify-between">
          {/* Prev button */}
          <motion.button
            whileTap={{ scale: 0.9 }}
            onClick={onPrevEvent}
            disabled={currentEventIndex === 0}
            className={`p-2.5 rounded-full border border-gray-200 min-w-[44px] min-h-[44px] flex items-center justify-center ${
              currentEventIndex === 0 ? 'opacity-30' : 'active:bg-gray-100'
            }`}
            data-testid="mobile-prev-btn"
          >
            <ChevronLeft className="w-5 h-5" />
          </motion.button>

          {/* Event title - clickable */}
          <motion.button
            whileTap={{ scale: 0.98 }}
            onClick={onEventClick}
            className="flex-1 mx-3 text-center min-h-[44px] flex flex-col justify-center"
            data-testid="mobile-event-info"
          >
            <p className="font-dm text-[10px] text-gray-400 uppercase tracking-wider">
              {currentEventIndex + 1}/{totalEvents}
            </p>
            <h3 className="font-league text-base uppercase tracking-wide text-black truncate">
              {currentEvent?.name}
            </h3>
            <p className="font-dm text-xs text-[#97c7c3]">
              {currentEvent?.displayDates}
            </p>
          </motion.button>

          {/* Next button */}
          <motion.button
            whileTap={{ scale: 0.9 }}
            onClick={onNextEvent}
            disabled={currentEventIndex === totalEvents - 1}
            className={`p-2.5 rounded-full border border-gray-200 min-w-[44px] min-h-[44px] flex items-center justify-center ${
              currentEventIndex === totalEvents - 1 ? 'opacity-30' : 'active:bg-gray-100'
            }`}
            data-testid="mobile-next-btn"
          >
            <ChevronRight className="w-5 h-5" />
          </motion.button>
        </div>
      </div>

      {/* Action buttons */}
      <div className="px-4 pb-4 pt-1 flex items-center justify-between gap-2">
        {/* View toggle */}
        <div className="flex items-center bg-gray-100 rounded-full p-1">
          <button
            onClick={() => onViewModeChange('map')}
            className={`p-2 rounded-full min-w-[40px] min-h-[40px] flex items-center justify-center transition-colors ${
              viewMode === 'map' ? 'bg-white shadow-sm' : ''
            }`}
            data-testid="mobile-view-map"
          >
            <MapPin className={`w-4 h-4 ${viewMode === 'map' ? 'text-[#97c7c3]' : 'text-gray-400'}`} />
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`p-2 rounded-full min-w-[40px] min-h-[40px] flex items-center justify-center transition-colors ${
              viewMode === 'list' ? 'bg-white shadow-sm' : ''
            }`}
            data-testid="mobile-view-list"
          >
            <List className={`w-4 h-4 ${viewMode === 'list' ? 'text-[#97c7c3]' : 'text-gray-400'}`} />
          </button>
        </div>

        {/* Find nearest */}
        <motion.button
          whileTap={{ scale: 0.95 }}
          onClick={onFindNearest}
          className="flex items-center gap-2 px-4 py-2.5 bg-gray-100 rounded-full min-h-[44px]"
          data-testid="find-nearest-btn"
        >
          <Navigation className="w-4 h-4 text-gray-600" />
          <span className="font-dm text-xs font-medium text-gray-600">Le plus proche</span>
        </motion.button>

        {/* Details button */}
        <motion.button
          whileTap={{ scale: 0.95 }}
          onClick={onEventClick}
          className="flex items-center gap-2 px-4 py-2.5 bg-black text-white rounded-full min-h-[44px]"
          data-testid="mobile-details-btn"
        >
          <Info className="w-4 h-4" />
          <span className="font-dm text-xs font-medium">Détails</span>
        </motion.button>
      </div>
    </motion.div>
  );
};
